import { render, staticRenderFns } from "./QuestionsSection.vue?vue&type=template&id=bef9e32e&scoped=true&"
import script from "./QuestionsSection.vue?vue&type=script&lang=js&"
export * from "./QuestionsSection.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsSection.vue?vue&type=style&index=0&id=bef9e32e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bef9e32e",
  null
  
)

export default component.exports